module.exports = __webpack_public_path__ + "static/mcSILVER-422687a9be3c52b9145ee57831e2f3b3.png";